import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const SearchAndFilter = ({ 
  searchQuery, 
  onSearchChange,
  sortBy,
  onSortChange,
  filterStatus,
  onFilterStatusChange,
  onAddNew,
  selectedCount = 0,
  onExport,
  onBulkDelete
}) => {
  const sortOptions = [
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
    { value: 'visits-desc', label: 'Most Visits' },
    { value: 'visits-asc', label: 'Least Visits' },
    { value: 'recent', label: 'Recent Appointment' },
    { value: 'oldest', label: 'Oldest Appointment' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Customers' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' }
  ];

  return (
    <div className="space-y-4">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
        <div className="relative flex-1 w-full lg:max-w-md">
          <Icon 
            name="Search" 
            size={20} 
            className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            placeholder="Search by name, phone, or email..."
            className="w-full pl-12 pr-4 py-3 bg-background border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background transition-smooth"
          />
          {searchQuery && (
            <button
              onClick={() => onSearchChange('')}
              className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-muted rounded transition-smooth"
              aria-label="Clear search"
            >
              <Icon name="X" size={16} className="text-muted-foreground" />
            </button>
          )}
        </div>

        <Button
          variant="default"
          iconName="UserPlus"
          iconPosition="left"
          onClick={onAddNew}
          className="w-full lg:w-auto"
        >
          Add New Customer
        </Button>
      </div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full sm:w-auto">
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Sort by..."
            className="w-full sm:w-48"
          />
          
          <Select
            options={statusOptions}
            value={filterStatus}
            onChange={onFilterStatusChange}
            placeholder="Filter status..."
            className="w-full sm:w-48"
          />
        </div>

        {selectedCount > 0 && (
          <div className="flex items-center gap-3 w-full sm:w-auto">
            <span className="text-sm text-muted-foreground whitespace-nowrap">
              {selectedCount} selected
            </span>
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={onExport}
            >
              Export
            </Button>
            <Button
              variant="destructive"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={onBulkDelete}
            >
              Delete
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAndFilter;